import { alpha } from '@mui/material/styles';
import { colorPalette } from '../../colorPalette';
export const menuPaperStyle = {
    minWidth: '220px',
    padding: '8px 10px',
    gap: '16px',
    borderRadius: '8px',
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
    mt: "4px"
};
export const menuItemStyle = {
    padding: '12px 14px',
    '& svg': {
        marginLeft: '-4px',
        paddingRight: '8px',
        fontSize: '1.8rem',
        color: colorPalette.gray400,
    },
    '&:active': {
        backgroundColor: alpha(colorPalette.gray200, 0.8),
    },
    '&:hover': {
        borderRadius: '8px',
        backgroundColor: colorPalette.gray100,
    },
};
export const menuListStyle = {
    padding: 0,
    color: colorPalette.gray900,
    fontSize: '1.4rem',
};
export const actionMenuStyle = (isOpened, sx, buttonColor, buttonVariant) => {
    const style = Object.assign(Object.assign({}, sx), { minWidth: 'auto', justifyContent: 'flex-end' });
    const backgroundColor = () => {
        switch (buttonColor) {
            case 'primary':
                if (buttonVariant === "contained")
                    return colorPalette.red600;
                else
                    return colorPalette.red200;
            case 'secondary':
                if (buttonVariant === "contained")
                    return colorPalette.gray600;
                else
                    return colorPalette.gray300;
            case 'seller':
                if (buttonVariant === "contained")
                    return colorPalette.green600;
                else
                    return colorPalette.green200;
            case 'tertiary':
            default:
                if (buttonVariant === "contained")
                    return colorPalette.gray300;
                else
                    return colorPalette.gray200;
        }
    };
    if (isOpened) {
        return Object.assign(Object.assign({}, style), { backgroundColor: backgroundColor() });
    }
    else
        return style;
};
export const iconStyle = {
    height: "20px",
    width: "20px"
};
